import React from 'react';
import { View, TouchableHighlight } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Icon } from '../../../Icon';
import { withTheme, LightThemeColors } from '../../../Themes';
import VFText from '../../../VFText';

import styles from './Option.Styles';

function Option({
  theme,
  item,
  index,
  dropdownCoordinates,
  onSelectItem,
  selectedItem,
  activeItemStyle,
  activeItemTextStyle,
  itemStyle,
  itemTextStyle,
  labelProps,
  getLabel,
  renderItem,
  isItemWithImage,
  itemImageStyle,
  itemImageSize,
  images,
}) {
  const renderImage = () => (
    <View style={itemImageStyle}>
      <Icon name={images[item?.icon] || item?.icon} size={itemImageSize} />
    </View>
  );
  return (
    <View
      key={index}
      onLayout={event => {
        const layout = event.nativeEvent.layout;
        dropdownCoordinates[index] = layout.y;
      }}
    >
      <TouchableHighlight
        underlayColor={theme.colors.picker.dropdownActiveItem}
        key={index}
        onPress={() => onSelectItem(item)}
        style={[
          styles.dropDownItem(item?.disabled),
          itemStyle,
          selectedItem.value === item.value && activeItemStyle,
        ]}
        disabled={item?.disabled || false === true}
      >
        <View style={styles.textContainer}>
          {_isFunction(renderItem) ? (
            renderItem(item)
          ) : (
            <>
              {isItemWithImage && renderImage()}
              <VFText
                i18nKey={getLabel(item)}
                style={[
                  styles.text(theme),
                  itemTextStyle,
                  selectedItem.value === item.value && activeItemTextStyle,
                ]}
                {...labelProps}
              />
            </>
          )}
        </View>
      </TouchableHighlight>
    </View>
  );
}

Option.defaultProps = {
  theme: LightThemeColors,
};
Option.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  item: PropTypes.objectOf({
    disabled: PropTypes.bool,
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  index: PropTypes.number,
  dropdownCoordinates: PropTypes.object,
  onSelectItem: PropTypes.func,
  selectedItem: PropTypes.objectOf({
    value: PropTypes.string,
  }),
  labelProps: PropTypes.object,
  getLabel: PropTypes.func,
  activeItemStyle: ViewPropTypes.style,
  itemStyle: ViewPropTypes.style,
  renderItem: PropTypes.func,
  isItemWithImage: PropTypes.bool,
  itemImageStyle: ViewPropTypes.style,
  itemImageSize: PropTypes.number,
  images: PropTypes.object,
  itemTextStyle: ViewPropTypes.style,
  activeItemTextStyle: ViewPropTypes.style,
};

export default withTheme(Option);
